var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLeftArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.08,
    height: 12.197,
    viewBox: "0 0 23.08 12.197",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICON_Arrowright",
    "data-name": "ICON  Arrowright",
    transform: "translate(-203.87 -114.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3568",
    "data-name": "Gruppe 3568",
    transform: "translate(203.87 114.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_914",
    "data-name": "Pfad 914",
    d: "M204.2,120.918l9.409,5.436a.666.666,0,0,0,.963-.8c-.734-2.051-1.871-5.216-1.893-5.214s1.122-3.144,1.871-5.193a.667.667,0,0,0-.962-.8l-9.388,5.42A.668.668,0,0,0,204.2,120.918Z",
    transform: "translate(-203.87 -114.25)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_720",
    "data-name": "Pfad 720",
    d: "M230.2,123.3H216.644",
    transform: "translate(-208.119 -117.26)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLeftArrow);
export default __webpack_public_path__ + "static/media/icon_left_arrow.bb807330f47b7372440481351c91e62c.svg";
export { ForwardRef as ReactComponent };